// @refresh reload
import { mount, StartClient } from '@solidjs/start/client';
import { initSentry as initClient } from '@bz/sentry';

import { resetCSR } from './utils/init';
import { devRetryFetch } from './utils/dev';
import { setupVitePreloadErrorHandle } from './utils/vitePreloadErrorHandle';

const initSentry = () => {
  const allowEnv = ['production', 'test'];
  const currentEnv = import.meta.env.VITE_STAGE;

  if (currentEnv && allowEnv.includes(currentEnv)) {
    initClient({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      sampleRate: 1,
      release: `${currentEnv}-${import.meta.env.VITE_APP_VERSION}`,
      environment: currentEnv,
    });
  }
};

initSentry();
resetCSR();
devRetryFetch();
setupVitePreloadErrorHandle();

mount(() => <StartClient />, document.getElementById('app')!);
